import { render, staticRenderFns } from "./ViewData.vue?vue&type=template&id=c8d696b2"
import script from "./ViewData.vue?vue&type=script&lang=ts"
export * from "./ViewData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports